import { QueryKey } from '@tanstack/react-query'
import RexService from 'services/rexService'
import { ActiveListing } from 'types/rex'

const GetActiveListingsForAgency = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<ActiveListing[] | undefined> => {
  const token = await getAuthToken()

  const agencyId = queryKey[1] as string
  const service = new RexService(token)

  const result = await service.rexService.get('GetActiveListingsForAgency', {
    agencyId,
  })

  return result.data
}

export default GetActiveListingsForAgency
